import React from 'react';
import './Donate.css';

const Donate: React.FC = () => {
  const donationMethods = [
    {
      icon: 'fas fa-university',
      title: 'Bank Transfer',
      details: [
        'GHAZANFAR BANK',
        'SWIFT: GHBKAFKAXXX'
      ],
      buttonText: 'View Details',
      buttonLink: '/contact',
    },
    {
      icon: 'fas fa-credit-card',
      title: 'Online Payment',
      details: [
        'Secure payment gateway',
        'Credit/Debit cards'
      ],
      buttonText: 'Coming Soon',
      buttonLink: '/contact',
      comingSoon: true
    },
    {
      icon: 'fas fa-hand-holding-usd',
      title: 'In-person',
      details: [
        'Kota-e-Sangi, Kabul',
        'Sunday - Thursday, 8AM-4PM'
      ],
      buttonText: 'Get Directions',
      buttonLink: '/contact'
    },
    {
      icon: 'fas fa-envelope',
      title: 'Via Email',
      details: [
        'info@nora.org.af',
        'Donation inquiries'
      ],
      buttonText: 'Send Email',
      buttonLink: '/contact',
    }
  ];

  const scopeOfWork = [
    {
      title: 'NORA: The Gateway to Hope',
      description: 'Your donation helps us deliver essential services in health, education, freelancing, and empowering women and children, enabling individuals and communities to thrive. Together, we turn compassion into lasting impact.',
      icon: 'fas fa-heartbeat'
    }
  ];

  return (
    <div className="donate-page">




      {/* Title Section with Red Underline */}
      <section className="clean-map-section">
        <div className="container">
          <div className="map-header">
            <h2 className="donate-title">{scopeOfWork[0].title}</h2>
            <p className="donate-subtitle">{scopeOfWork[0].description}</p>
          </div>
        </div>
      </section>




      {/* Donation Methods - Reduced gap from title */}
      <section  style={{ paddingBottom: '60px' }} className="donation-methods">
        <div className="container">
          <div className="donation-cards-grid">
            {donationMethods.map((method, index) => (
              <div key={index} className={`donation-card ${method.comingSoon ? 'coming-soon' : ''}`}>
                <div className="card-header">
                  <div className="card-icon">
                    <i className={method.icon}></i>
                  </div>
                  <h3>{method.title}</h3>
                </div>
                
                <div className="card-details">
                  {method.details.map((detail, idx) => (
                    <p key={idx} className="detail-item">{detail}</p>
                  ))}
                </div>

                <a 
                  href={method.buttonLink} 
                  className={`donate-button`}
                >
                  {method.buttonText}
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Donate;